/* eslint-disable react/prop-types */
import {
  Form,
  Modal,
  Row,
  Spin,
} from 'antd';
import { getEstadosGlobales, getTiposDeVialidades } from 'api/catalogos';
import { getDirecciones } from 'api/catalogos/Direccion';
import { getTipoDirecciones } from 'api/catalogos/TiposDireccion';
import { getHistoricosMovimientosEmpleados } from 'api/nominas/historicoMovimientosEmpleados';
import { checkToken } from 'api/utils';
import Dragger from 'components/Dragger';
import FormSubmitControls from 'components/FormSubmitControls';
import Table from 'components/Table';
import moment from 'moment/moment';
import React, { useEffect, useState } from 'react';
import HTTP, { baseURL } from 'utils/api';
import { ESTATUS_ACTIVO } from 'utils/constants';
import { formatReceived } from 'utils/formatValues';
import { onError, onSuccess } from 'utils/handlers';
import { getModelPermission } from 'utils/permission';

export const HistoricoMovimientoEmpleadoPermission = {
  permissionModel: 'historicomovimientoempleado',
  catalogsModels: [],
  tabsModels: [],
};

const baseURI = 'nominas/movimientos-empleados-importar-excel';

const ExpedienteDirecciones = ({
  currentEmpleado,
}) => {
  const [data, setData] = useState([]);
  const [loading, setLoading] = useState(false);
  const [visibleModal, setVisibleModal] = useState(false);
  const [formCarga] = Form.useForm();
  const [estados, setEstados] = useState([]);
  const [tiposDeVialidades, setTiposDeVialidades] = useState([]);
  const [tiposDeDireccion, setTiposDeDireccion] = useState([]);
  const [selectedRowKeys, setSelectedRowKeys] = useState([]);
  const [pageActual, setPageActual] = useState(1);
  const [selectedData, setSelectedData] = useState({});

  const getPermission = getModelPermission(
    HistoricoMovimientoEmpleadoPermission.permissionModel,
    HistoricoMovimientoEmpleadoPermission.catalogsModels,
    HistoricoMovimientoEmpleadoPermission.tabsModels,
    false,
  );

  const fetchData = async () => {
    setLoading(true);
    const _data = await getDirecciones({ empleado: currentEmpleado });
    setData(formatReceived(_data));
  };

  const baseURI2 = '/estructura-organizacional/empleados-domicilios';
  const fetchPaginated = async (page = 1, q = null) => {
    try {
      setLoading(true);

      const cleanPage = Number(String(page).replace(/\D/g, '')); // solo dígitos
      const response = await HTTP.get(baseURI2, { params: { page: cleanPage, ...q } });

      const { results } = response.data;

      setSelectedRowKeys([]);
      setPageActual(cleanPage);
      setData({ ...response.data, results });
      setLoading(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  useEffect(() => {
    let mounted = true;
    const fetchAll = async () => {
      setLoading(true);
      await checkToken();
      const [
        _tiposDeDireccion,
        _tiposDeVialidades,
        _estados,
        _data,
      ] = await Promise.all([
        getTipoDirecciones(),
        getTiposDeVialidades(),
        getEstadosGlobales(),
        getDirecciones({ empleado: currentEmpleado }),
      ]);
      if (mounted) {
        setTiposDeDireccion(_tiposDeDireccion);
        setEstados(_estados);
        setTiposDeVialidades(_tiposDeVialidades);
        let { results } = _data;

        results = results.sort((a, b) => {
          // eslint-disable-next-line max-len
          if (a.estados_globales === ESTATUS_ACTIVO && b.estados_globales !== ESTATUS_ACTIVO) return -1;
          // eslint-disable-next-line max-len
          if (a.estados_globales !== ESTATUS_ACTIVO && b.estados_globales === ESTATUS_ACTIVO) return 1;
          return 0;
        });
        setData({ ..._data, results });
        setLoading(false);
      }
    };
    if (currentEmpleado) {
      fetchAll();
    } else {
      setData([]);
      setLoading(false);
    }
    return () => { mounted = false; };
  }, [currentEmpleado]);

  const onCancel = () => {
    setVisibleModal(false);
    formCarga.resetFields();
  };

  // const onClickObtenerPlantilla = async () => {
  //   try {
  //     setLoading(true);
  //     const excel = await getHistoricoMovimientosEmpleadosPlantilla();
  //     if (excel) {
  //       const blob = new Blob([excel], {
  //         type: 'application/ms-excel',
  //       });
  //       const url = URL.createObjectURL(blob);
  //       const link = document.createElement('a');
  //       link.href = url;
  //       link.download = 'ExpedienteDirecciones_Plantilla.xlsx';
  //       link.click();
  //     }
  //     setLoading(false);
  //   } catch (err) {
  //     onError(err);
  //   }
  // };

  // const onClickCargar = () => {
  //   setVisibleModal(true);
  // };

  const onUpload = async () => {
    try {
      await formCarga.validateFields();
      const { file } = formCarga.getFieldsValue();
      if (file) {
        setLoading(true);
        const formData = new FormData();
        formData.append('archivo', file.file);
        const uri = baseURI.at(-1) === '/' ? baseURI : `${baseURI}/`;
        const response = await HTTP.post(`${baseURL}${uri}`, formData, {
          headers: {
            'Content-Type': 'application/ms-excel',
          },
          responseType: 'arraybuffer',
        });
        if (response?.data) {
          const blob = new Blob([response?.data], {
            type: 'application/ms-excel',
          });
          const url = URL.createObjectURL(blob);
          const link = document.createElement('a');
          link.href = url;
          link.download = 'ExpedienteDirecciones_Respuesta.xlsx';
          link.click();
        }
        if (response?.status === 200) {
          onSuccess(response, 'Operación realizada correctamente', 5);
          await fetchData();
          onCancel();
        }
      }
      setLoading(false);
      setVisibleModal(false);
    } catch (err) {
      onError(err, setLoading);
    }
  };

  // const menuImport = (
  //   <Menu
  //     items={[
  //       {
  //         key: 1,
  //         label: 'Obtener Plantilla',
  //         text: 'Obtener Plantilla',
  //         icon: <FileExcelOutlined />,
  //         onClick: () => onClickObtenerPlantilla(),
  //       },
  //       {
  //         key: 2,
  //         label: 'Cargar',
  //         text: 'Cargar',
  //         icon: <DownloadOutlined />,
  //         onClick: () => onClickCargar(),
  //       },
  //     ]}
  //   />
  // );

  const handleOnRowClick = (record) => {
    setSelectedRowKeys([record.id]);
    setSelectedData({ ...record });

    const dataForForm = {
      ...record,
      vigencia_final: record.vigencia_final
        ? moment(record.vigencia_final)
        : null,
    };

    formCarga.setFieldsValue(dataForForm);
  };

  const requiredRule = {
    required: true,
    message: 'El campo es requerido',
  };

  const rules = {
    required: [requiredRule],
  };

  const columns = [
    {
      titleText: 'ID',
      dataIndex: 'id',
      key: 'id',
      width: 60,
    },
    {
      titleText: 'Tipo de Dirección',
      dataIndex: 'tipo_de_direccion',
      key: 'tipo_de_direccion',
      width: 120,
      render: (val) => val?.descripcion || 'sin tipo',
    },
    {
      titleText: 'País',
      dataIndex: ['codigo_postal', 'municipio', 'estado', 'pais'],
      key: 'pais',
      width: 100,
      render: () => 'México', // si no viene en la API, se puede poner estático
    },
    {
      titleText: 'Estado',
      dataIndex: ['codigo_postal', 'municipio', 'estado', 'descripcion'],
      key: 'estado',
      width: 100,
      render: (_, record) => record?.codigo_postal?.municipio?.estado?.descripcion || '',
    },
    {
      titleText: 'Municipio',
      dataIndex: ['codigo_postal', 'municipio', 'descripcion'],
      key: 'municipio',
      width: 100,
      render: (_, record) => record?.codigo_postal?.municipio?.descripcion || '',
    },
    {
      titleText: 'Colonia',
      dataIndex: 'colonia',
      key: 'colonia',
      width: 120,
    },
    {
      titleText: 'Código Postal',
      dataIndex: ['codigo_postal', 'd_codigo'],
      key: 'd_codigo',
      width: 100,
      render: (_, record) => record?.codigo_postal?.d_codigo || record?.empleado?.codigo_postal || '',
    },
    {
      titleText: 'Número Exterior',
      dataIndex: 'numero_exterior',
      key: 'numero_exterior',
      width: 100,
    },
    {
      titleText: 'Número Interior',
      dataIndex: 'numero_interior',
      key: 'numero_interior',
      width: 100,
    },
    {
      titleText: 'Tipo de Vialidad',
      dataIndex: 'tipo_de_vialidad',
      key: 'tipo_de_vialidad',
      width: 120,
      render: (val) => tiposDeVialidades.find((v) => v.id === val)?.descripcion || '',
    },
    {
      titleText: 'Vialidad',
      dataIndex: 'calle_principal',
      key: 'calle_principal',
      width: 120,
    },
    {
      titleText: 'Tipo de Vialidad Entre',
      dataIndex: 'tipo_de_vialidad_entre',
      key: 'tipo_de_vialidad_entre',
      width: 120,
    },
    {
      titleText: 'Entre Vialidad',
      dataIndex: 'entre_calle',
      key: 'entre_calle',
      width: 120,
    },
    {
      titleText: 'Tipo de Vialidad Y Calle',
      dataIndex: 'tipo_de_vialidad_y_calle',
      key: 'tipo_de_vialidad_y_calle',
      width: 120,
    },
    {
      titleText: 'Y Vialidad',
      dataIndex: 'y_calle',
      key: 'y_calle',
      width: 120,
    },
    {
      titleText: 'Descripción de la Ubicación',
      dataIndex: 'descripcion_de_la_ubicacion',
      key: 'descripcion_de_la_ubicacion',
      width: 180,
    },
    {
      titleText: 'Vigencia',
      dataIndex: 'vigencia_final',
      key: 'vigencia_final',
      width: 100,
      render: (vigencia) => (vigencia ? new Date(vigencia).toLocaleDateString() : 'Sin fecha'),
    },
    {
      titleText: 'Observaciones',
      dataIndex: 'observaciones',
      key: 'observaciones',
      width: 160,
      render: (_, record) => {
        if (!record.calle_principal || !record.colonia) {
          return 'Falta registrar una Dirección';
        }
        return record.observaciones || '';
      },
    },
    {
      titleText: 'Estatus',
      dataIndex: 'estados_globales',
      key: 'estados_globales',
      width: 200,
      render: (val) => estados.find((e) => e.id === val)?.descripcion,
    },
  ];

  return (
    <Row className="container">
      <Spin tip="Cargando..." spinning={loading}>
        <Table
          cols={columns}
          data={data?.results || []}
          pagination={false}
          paginationCallback={fetchPaginated}
          count={data?.count || 0}
          permission={getPermission}
          // allowCustomImport
          // customImportMenu={menuImport}
          // customImportText="Importar Movimientos Empleados"
          // allowExportPDF={false}
          loading={loading}
        />
        <Modal
          open={visibleModal}
          title={(
            <FormSubmitControls
              label="Carga Masiva"
              onFinish={onUpload}
              onCancel={onCancel}
              loading={loading}
            />
          )}
          onCancel={onCancel}
          footer={null}
          closable={false}
          maskClosable={!loading}
          keyboard={!loading}
          forceRender
          destroyOnClose
        >
          <Spin tip="Cargando..." spinning={loading}>
            <Form
              layout="vertical"
              form={formCarga}
              name="carga"
              onFinish={onUpload}
            >
              <Dragger
                label="Archivo"
                limitMB={30}
                rules={rules.required}
                name="file"
                allowedExtensions={['xlsx']}
              />
            </Form>
          </Spin>
        </Modal>
      </Spin>
    </Row>
  );
};

export default ExpedienteDirecciones;
